import { render, staticRenderFns } from "./fill.vue?vue&type=template&id=23960c8c&scoped=true&"
import script from "./fill.vue?vue&type=script&lang=ts&"
export * from "./fill.vue?vue&type=script&lang=ts&"
import style0 from "./fill.vue?vue&type=style&index=0&id=23960c8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23960c8c",
  null
  
)

export default component.exports